<template>
  <AppLink :to="url" :target="target">
    <div
      v-tooltip="props.collapsed ? text : ''"
      class="
      flex w-fit cursor-pointer items-center border-l-4
      transition-colors duration-150"
      :class="{
        'border-l-[--v3-theme-primarycolor] bg-[--v3-theme-primarycolor] text-[--v3-theme-primarytextcolor] hover:border-l-[--v3-theme-primarydarkestcolor] hover:bg-[--v3-theme-primarydarkercolor] hover:text-[--v3-theme-primarytextcolor]': !active,
        'border-l-[--v3-theme-primarydarkestcolor] bg-[--v3-theme-primarydarkercolor] text-[--v3-theme-primarytextcolor] hover:bg-[--v3-theme-primarydarkestcolor] hover:text-[--v3-theme-primarytextcolor]': active,
      }"
    >
      <div v-if="icon" class="flex w-[46px] items-center justify-center">
        <Icon
          class="ml-[-4px] size-full"
          :class="{
            'text-[--v3-theme-primarytextcolor]': active,
          }"
          :name="icon"
          :height="20"
          :width="20"
        />
      </div>
      <div
        class="flex h-[51px] translate-x-[-3px] items-center transition-[width,opacity,font-size]"
        :class="{
          'ml-[15px]': !icon,
          'collapsed w-0 text-[0px] opacity-0': collapsed,
          'collapsed text-[14px] opacity-100': !collapsed,
          'w-[258px]': !icon && !collapsed,
          'w-[227px]': icon && !collapsed,
        }"
      >
        <span class="link-name font-medium leading-[21px]">
          {{ text }}
        </span>
      </div>
    </div>
  </AppLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import AppLink from '@/common/components/atoms/AppLink';
import Icon from '@/common/components/atoms/Icon';

const props = withDefaults(defineProps<{
  /** Route Url to navigate to,
   * if both to and legacyUrl are provided, 'to' will be used */
  to?: string | null | undefined,
  /** The legacy V2 URL to navigate to  */
  legacyUrl?: string | null | undefined,
  text: string,
  icon?: string,
  active?: boolean,
  collapsed?: boolean,
  target?: string,
}>(), {
  active: false,
  collapsed: false,
  legacyUrl: null,
  to: null,
  icon: null,
  target: '_self',
});

const url = computed(() => props.to || props.legacyUrl);
</script>
